const client = require("contentful").createClient({
  space: "ir647vmdjwki",
  accessToken: "liL3rOdtpLXgc7p0Yw58Rqna1fWovAtLW312uv-UkRc",
});

const getNews = () =>
  client
    .getEntries({ content_type: "actuell" })
    .then((response) => response.items);

const getClassNews = () =>
  client
    .getEntries({ content_type: "actuellKlasse" })
    .then((response) => response.items);

const getClassNews2 = () =>
  client
    .getEntries({ content_type: "actuellKlasse2" })
    .then((response) => response.items);

const getHomepageVideo = () =>
  client
    .getEntries({ content_type: "homepageVideo" })
    .then((response) => response.items);

const getGalleryImages = () =>
  client
    .getEntries({ content_type: "galleryImage" })
    .then((response) => response.items);

const getYoutube = () =>
  client
    .getEntries({ content_type: "video" })
    .then((response) => response.items);

const getEnsemblePage = () =>
  client
    .getEntries({ content_type: "ensembleText" })
    .then((response) => response.items);

const getRecordings = () =>
  client
    .getEntries({ content_type: "recording", order: "fields.order" })
    .then((response) => response.items);

const getProgrammes = () =>
  client
    .getEntries({ content_type: "programme" })
    .then((response) => response.items);

const getPortrait = () =>
  client
    .getEntries({ content_type: "portrait" })
    .then((response) => response.items);

const getSingleProgramme = (slug) =>
  client
    .getEntries({ content_type: "programme", "sys.id": slug })
    .then((response) => response.items);

const getSinglePost = (slug) =>
  client
    .getEntries({
      "sys.id": slug,
      content_type: "observationJournal",
    })
    .then((response) => response.items);

const getImpressum = () =>
  client
    .getEntries({ content_type: "impressum" })
    .then((response) => response.items);

export {
  getImpressum,
  getPortrait,
  getProgrammes,
  getSingleProgramme,
  getSinglePost,
  getNews,
  getGalleryImages,
  getYoutube,
  getRecordings,
  getEnsemblePage,
  getClassNews,
  getClassNews2,
  getHomepageVideo,
};
